<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="empty-description"
    :class="cn('text-sm text-body [&>a]:underline [&>a]:underline-offset-4', props.class)"
  >
    <slot />
  </div>
</template>
